import script from "./App.vue?vue&type=script&lang=ts&setup=true&async=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true&async=true"

import "./App.vue?vue&type=style&index=0&id=2f89540e&lang=css"

const __exports__ = script;

export default __exports__